import React, { useEffect } from 'react';
import theme from '../styles/theme';
import { usePostContext } from '../contexts/PostContext';

import { Header, Spinner, Text } from '../components/atoms';
import { QuestionItem } from '../components/organisms';
import { useUserContext } from '../contexts/UserContext/index';

const QuestionsPage = () => {
  const {
    user: { id: userId },
  } = useUserContext();

  const { myPosts, handleGetMyPosts, isLoading } = usePostContext();

  useEffect(() => {
    if (userId) {
      handleGetMyPosts(userId);
    }
  }, [handleGetMyPosts, userId]);

  return (
    <>
      <Header style={{ marginBottom: theme.spacing.xl }}>내가 쓴 질문</Header>
      {/* NOTE: 여기에 분기문으로 넣으면 렌더링 다 언마운트되고 다시 마운트되는데 괜찮은걸까? */}
      {isLoading ? (
        <Spinner />
      ) : (
        myPosts.map((post) => <QuestionItem key={post.id} post={post} />)
      )}
      {!isLoading && myPosts.length === 0 ? (
        <Text>작성한 질문이 없습니다😥</Text>
      ) : null}
    </>
  );
};

export default QuestionsPage;
